'use client'
import { Cart } from "lib/bigcommerce/types";

export const ProductView = (
  siteId: string, 
  shopperId: string, 
  sku: string,
  gid: string,
) => {
  if (!window) return {};
  try {
    window.IntelliSuggest.init({
      siteId,
      context: `Product/${sku}`,
      seed: [sku]
    });
    window.IntelliSuggest.setShopperId(shopperId);
    window.IntelliSuggest.viewItem({ 
      sku: sku, 
      uid: gid 
    });
  } catch (err) {
    console.error('IntelliSuggest error:', err);
  }
};

export const BasketItems = (siteId:string, shopperId:string, cart: Cart) => {
  if (!window) return {};
    try {
      window.IntelliSuggest.init({
        siteId,
        context: 'Basket',
        seed: cart.lines.map(item => item.parentSKU)
      });
      window.IntelliSuggest.setShopperId(shopperId);
      
      cart.lines.forEach(item => {
        const intelliItem = {
          sku: item.parentSKU,
          childSku: item.sku,
          qty: item.quantity.toString(),
          price: item.cost.totalAmount.amount
        }
        window.IntelliSuggest.haveItem(intelliItem);
      });
      
      window.IntelliSuggest.inBasket({});
    } catch (err) {
      console.error('IntelliSuggest error:', err);
    }
};

  